export const ACTIONS = require("./actions")
export const ENDPOINTS = require("./endpoints")

// filters
export const FILTER_IN_ALL_FOLDERS_INIT_VALUE = 0
export const FILTER_IN_ALL_FOLDERS = "external"
